import {
    get,
    post,
    execute
} from "../axios";

/**
 * 登录接口
 * @param {data} 
 * @return {Promise} 
 */
export const LoginByUsername = data => execute('api/v1/Login/LoginCheck', data)

/**
 * 手机号+验证码登录接口
 * @param {data} 
 * @return {Promise} 
 */
export const LoginByMobile = data => execute('api/v1/Login/LoginCheck_VerCode', data)

/**
 * 对超时的accessToken,使用refreshtokne对accesstoken进行更新
 * @param {data} 
 * @return {Promise} 
 */
export const LoginUpdate = data => execute('api/V1/Login/LoginUpdate', data)

/**
 * 获取登录验证码
 * @param {mobile} 
 * @return {Promise} 
 */
export const GetLoginVerCode = data => execute('api/v1/Login/SendVerCode_Login', data)

/**
 * 用户注册时获取短信验证码
 * @param {mobile} 
 * @return {Promise} 
 */
export const GetVerCode = data => execute('api/v1/Login/SendVerCode_Register', data)

/**
 * 用户密码找回时获取短信验证码接口
 * @param {mobile} 
 * @return {Promise} 
 */
export const FindPassSendVerCode = data => execute('api/v1/Login/SendVerCode_FindPassword', data)

/**
 * 检测手机号是否已注册
 * @param {mobile} 
 * @return {Promise} 
 */
export const CheckMobileIsRegisted = data => execute('api/v1/Login/CheckMobileIsRegisted', data)

/**
 * C端用户注册
 * @param {data} 
 * @return {Promise} 
 */
export const UserRegister = data => execute('api/v1/Login/UserRegister', data)

/**
 * 提交保存密码找回请求
 * @param {data} 
 * @return {Promise} 
 */
export const SaveFindPass = data => execute('api/v1/Login/SaveFindPassword', data)

/**
 * 获取微信二维码生成参数
 * @param {data} 
 * @return {Promise} 
 */
export const GetWxWebSiteQrInfo = data => execute('api/V1/Login/GetWxWebSiteQrInfo', data)

/**
 * 根据Code登录
 * @param {data} 
 * @return {Promise} 
 */
export const LoginCheckByCode = data => execute('api/V1/Login/LoginCheckWebSiteQr', data)

/**
 * 根据sign登录
 * @param {data} 
 * @return {Promise} 
 */
export const LoginCheckBySign = data => execute('api/V1/Login/LoginCheckWebSiteChoseSign', data)